import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const notifications = [{
  flagCode: 'es',
  countryName: 'Spain',
  location: 'Madrid, Spain',
  name: 'Javier Molina',
  initials: 'JM',
  time: '5 minutes ago'
}, {
  flagCode: 'mx',
  countryName: 'Mexico',
  location: 'Mexico City, Mexico',
  name: 'Rosa Castillo',
  initials: 'RC',
  time: '12 minutes ago'
}, {
  flagCode: 'br',
  countryName: 'Brazil',
  location: 'São Paulo, Brazil',
  name: 'Lucas Santos',
  initials: 'LS',
  time: '18 minutes ago'
}, {
  flagCode: 'co',
  countryName: 'Colombia',
  location: 'Bogotá, Colombia',
  name: 'Felipe Cardona',
  initials: 'FC',
  time: '27 minutes ago'
}, {
  flagCode: 'pe',
  countryName: 'Peru',
  location: 'Lima, Peru',
  name: 'Ana Rojas',
  initials: 'AR',
  time: '41 minutes ago'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const timer = window.setTimeout(() => setIsVisible(true), 3000);
    return () => window.clearTimeout(timer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = window.setTimeout(() => {
      setIsVisible(false);
      window.setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(previous => (previous + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => window.clearTimeout(hideTimer);
  }, [currentIndex, isDismissed, isVisible]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" data-id="element-204" data-mp="yj4xoajj2w5w">
      <AnimatePresence mode="wait" data-id="element-205" data-mp="3n8w423w95v05">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 40,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border border-silver-light rounded-xl p-3.5 shadow-[0_10px_30px_-12px_rgba(27,26,25,0.3)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-206" data-mp="3j82dt3vc8443">
            <button type="button" onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-graphite-light hover:text-ink transition-colors duration-150 ease-out" aria-label="Close notification" data-id="element-207" data-mp="3201et958tx7a">
              <X size={14} data-id="element-208" data-mp="2x0ov2x9o568x" />
            </button>
            <div className="flex items-center gap-3" data-id="element-209" data-mp="2x1ht99ukanfg">
              <div className="relative shrink-0" data-id="element-210" data-mp="2j0xc0i4aozo2">
                <div className="w-11 h-11 rounded-full bg-brand flex items-center justify-center text-white font-bold text-sm" data-id="element-211" data-mp="2j28mf0s8x5o5">
                  {current.initials}
                </div>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`${current.countryName} flag`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-white shadow" data-id="element-212" data-mp="24f9y3eooqrdn" />
              </div>
              <div className="flex-1 min-w-0 pr-4" data-id="element-213" data-mp="28f0npf2h71gl">
                <div className="flex items-center gap-1.5 text-[11px] text-graphite-light mb-0.5" data-id="element-214" data-mp="2nd2urz8pu52l">
                  <img src={`https://flagcdn.com/w20/${current.flagCode}.png`} alt="" className="w-4 h-3 rounded-sm object-cover" data-id="element-215" data-mp="2if16mzwfnfk9" />
                  <span className="truncate" data-id="element-216" data-mp="2s5dr6s48z8qe">{current.location}</span>
                </div>
                <p className="text-ink text-[13px] leading-snug" data-id="element-217" data-mp="363aqvxdzzv9a">
                  <span className="font-bold" data-id="element-218" data-mp="3150u5icmkmlk">{current.name}</span>{' '}
                  <span className="text-graphite" data-id="element-219" data-mp="316u354apniwq">purchased Ninja Coach Ready™</span>
                </p>
                <div className="flex items-center gap-1.5 text-[10px] text-brand-dark font-medium mt-1" data-id="element-220" data-mp="3l6vfxheeja3f">
                  <span className="w-1.5 h-1.5 rounded-full bg-brand" data-id="element-221" data-mp="3p6m91rrei2b4" />
                  <ShoppingBag size={10} aria-hidden="true" data-id="element-222" data-mp="3u0qm8sr9f6kn" />
                  <span data-id="element-223" data-mp="2tnrjrc7qi5o">Verified purchase • {current.time}</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}